import { getEditLocation } from "../../../core/util/functions";

export const payTypesLocation = "/listing/codebook/paytypes";
export const getPayTypeEditLocation = (id?: string) => getEditLocation(payTypesLocation, undefined, id);

export const editRouter = getPayTypeEditLocation(":paytypeId?");
